<template>
    <div id="app" :class="{ 'container': isShowContainer }">
        <div class="app-loading" v-if="$store.state.LOADING">
            <van-loading type="spinner" color="#1989fa"/>
        </div>
        <router-view/>
        <AudioPlayer hidden />
    </div>
</template>
<script>
import { checkClientIsMobile } from '@/utils'
import AudioPlayer from '@/components/audioPlayer/index.vue'

export default {
    components: { AudioPlayer },
    data () {
        return {
            isShowContainer: false,
        }
    },
    async mounted () {
        if (!checkClientIsMobile()) {
            require('@/assets/css/pc/pc.scss')
            this.isShowContainer = true
        } else {
            require('@/assets/css/mobile/index.scss')
            this.isShowContainer = false
        }

        window.addEventListener('resize', () => {
            setTimeout(() => {
                if (!checkClientIsMobile()) {
                    require('@/assets/css/pc/pc.scss')
                    this.isShowContainer = true
                } else {
                    require('@/assets/css/mobile/index.scss')
                    this.isShowContainer = false
                }
            }, 50)
        })
    },
}
</script>

<style lang="scss">
@import "@/assets/css/public.scss";

.app-loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>
